<style scoped>
  .bg-color {
    background-color: #f7f7f7;
  }
</style>
<script>

export default {
  name: 'AuthProcess',

  data () {
    return {
      param: ''
    }
  },

  mounted () {
    this.$store.commit('lightBoxloaderOn', false)
    this.param = JSON.parse(atob(this.$route.query.res))
    if (window.opener) {
      window.opener.postMessage(this.param)
    }
  }
}
</script>
<template>
  <div class="bg-color d-flex justify-content-center align-items-center vh-100">
    <div class="text-center">
      <div
        class="spinner-border text-primary"
        role="status" />
      <p class="mt-3 text-black">Processing, please wait...</p>
    </div>
  </div>
</template>
